import * as Dtos from '../../dtos/Tmd.dtos';
import { IFieldState, IRegistrationFormState } from "./index";

export const initialFellowshipState: Dtos.Fellowship & IRegistrationFormState = {
    id: null,
    fellowId: null,
    fellow: null,
    supervisorId: null,
    supervisor: null,
    projectTitle: null,
    disciplineId: null,
    awarded: null,
    dateStart: null,
    dateExpectedCompletion: null,
    dateSixMonthReportDue: null,
    dateSixMonthReportReceived: null,
    dateFinalOutcomeReportDue: null,
    dateFinalOutcomeReportReceived: null,
    enteredBy: null,
    modifiedBy: null,
    active: null,
    saveAndReturn: false,
    sourceDocuments: []
}

export interface IFellowshipReduxFormState {
    id: IFieldState<number>,
    fellowId: IFieldState<number>,
    fellow: IFieldState<Dtos.Personnel>,
    supervisorId: IFieldState<number>,
    supervisor: IFieldState<Dtos.Personnel>,
    projectTitle: IFieldState<string>,
    disciplineId: IFieldState<number>,
    awarded: IFieldState<boolean>,
    dateStart: IFieldState<string>,
    dateExpectedCompletion: IFieldState<string>,
    dateSixMonthReportDue: IFieldState<string>,
    dateSixMonthReportReceived: IFieldState<string>,
    dateFinalOutcomeReportDue: IFieldState<string>,
    dateFinalOutcomeReportReceived: IFieldState<string>,
    dateEntered: IFieldState<string>,
    dateModified: IFieldState<string>,
    enteredBy: IFieldState<string>,
    active: IFieldState<boolean>
}
